import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=74d9859a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/dashboard.scss?vue&type=style&index=0&id=74d9859a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d9859a",
  null
  
)

export default component.exports